










import { Component, Vue } from 'vue-property-decorator';
import AppHeader from '@/organisms/headers/default.vue';
import AppFooter from '@/organisms/footers/default.vue';

@Component({
  components: {
    'app-header': AppHeader,
    'app-footer': AppFooter,
  },
})
export default class Default extends Vue {


}
